<div class="link">
  <button
    type="button"
    class="btn btn-link btn-link--{{ color() }} text-start focus-border-large"
    (click)="actionClicked.emit()"
    [attr.data-test]="dataTest()"
  >
    @if (icon()) {
      <i class="pr-1 fas fa-{{ icon() }}"></i>
    }
    {{ text() | translate }}
  </button>
</div>
